import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProviderPaymentsBulk } from '../../features/salesOrder/components/ProviderPaymentsBulk';
import { ProviderPaymentsNav } from './ProviderPaymentsNav';

export const ProviderPaymentsBulkPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container spacing={2} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<Typography variant="h4" gutterBottom>
						Pagos a Proveedores
					</Typography>
					<ProviderPaymentsNav />
					<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
						Importá pagos a proveedores desde un archivo CSV. Se validan los montos contra el pendiente de cada línea
						antes de confirmar.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<ProviderPaymentsBulk />
				</Grid>
			</Grid>
		</Layout>
	);
};
